<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-24T11:44:01+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe: List brand images
@Last modified by:   tom
@Last modified time: 2019-06-12T17:49:09+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">

  <!-- list all tech brands -->
  <b-container id="brandlist" class="mb-2">
    <!-- <router-link :to="{name:'Technology'}"> -->
    <b-row align-v="center">
      <b-col
        v-for="f in 4"
        :key = "f"
        class="pl-2">
        <lzimg
          :src="assetUrl('img/seals/'+ $t('puck.about.chatapps.' + f))"
          fluid
          width="130" />
      </b-col>
    </b-row>
    <!-- </router-link> -->
  </b-container>

</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

  #brandlist {
  //  margin-top: 20px;
    height: 40px; // avoid lazy load artifacts on page
  }

</style>
